import React from 'react'
import { Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const About = () => {
    return (
        <Fragment>
            <section className='relative overflow-hidden min-h-screen pt-[88px] lg:pt-[98px] -mt-[88px] lg:-mt-[98px] bg-MsoftYellow flex flex-wrap pb-0'>
                <img src="./assets/images/001.svg" className='absolute left-0 top-0 w-full h-full object-cover' alt="" />
                <Container className='relative z-[2] w-full pt-[80px] relative'>
                    <Row className='justify-center relative z-2'>
                        <Col md={10} className='text-center' >
                            <h5 className='font-medium text__18 text-Myellow mb-3'>ABOUT US</h5>
                            <h1 className='font-medium text__64 text-Mblack mb-3 relative'>
                                <img src="./assets/images/Vector (1).png" className='absolute w-[50px] lg:w-auto right-0 md:-right-[4rem] -top-[4.5rem]' alt="" />
                                <span className="relative">
                                    <img src="./assets/images/Vector.png" className='absolute -left-[3.5rem] -top-[2.5rem] w-[50px] lg:w-auto' alt="" />
                                    <span className='relative z-2'>Where</span>
                                </span> passion for homemade food meets community connection!
                            </h1>
                            <p className='leading-[30px] text__18'>At Pantria, we believe food tastes better when it's made by hand, not machine<br />—and even better when shared.</p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='bg-white lg:pb-[80px] pb-0 mx-[16px] rounded-tl-[40px] rounded-tr-[40px]'>
                <Container>
                    <Row className='gap-y-6'>
                        <Col md={6} className='my-auto'>
                            <img src="./assets/pantria/community_sample.png" alt="" />
                        </Col>
                        <Col md={6} className='my-auto'>
                            <h2 className='font-medium text__48 mb-3'>Our Mission</h2>
                            <p className='text__18 mb-3'>Born from a passion for real, homemade flavours, we're on a mission to connect food lovers and home cooks across the UK. Whether you're a baker with a secret-recipe sourdough, a busy parent selling hearty meals, or simply someone who craves food made the old-fashioned way, Pantria is your table.</p>
                            <p className='text__18'>We celebrate the stories behind every dish—the late-night jam sessions, the passed-down family recipes, the "I just winged it" triumphs.</p>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='bg-white mx-[16px] rounded-bl-[40px] rounded-br-[40px]'>
                <Container>
                    <Row className='gap-y-6'>
                        <Col md={6} className='my-auto md:!order-1 order-2'>
                            <h2 className='font-medium text__48 mb-3'>Our Promise</h2>
                            <p className='text__18 mb-3'>Because great food isn't just about ingredients; it's about connection. Here, pantries become businesses, neighbours become suppliers, and every bite comes with a backstory.</p>
                            <p className='text__18'>Join us. Trade generously, eat intentionally, and keep homemade alive.</p>
                        </Col>
                        <Col md={6} className='my-auto order-1 md:!order-2'>
                            <img src="./assets/pantria/pantry_sample.png" alt="" />
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Call to Action */}
            <section className='bg-[#F8F8F8] py-[80px]'>
                <Container>
                    <Row className='justify-center'>
                        <Col md={8} className='text-center'>
                            <h2 className='font-medium text__48 mb-3'>Join Our Pantria Community</h2>
                            <p className='text__18 mb-6'>Ready to start your homemade food journey? Get in touch and be part of the community.</p>
                            <a href="#contact" className='inline-block cursor-pointer text-center font-medium text__16 text-white !py-[15px] !px-[28px] bg-Morange !border-Morange btnClass hover:bg-[#E66B00]'>
                                Get Started
                            </a>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default About